import {
  SearchFilters,
  payFullRange,
  payMonthlyRange,
} from '@cinch-nx/data-search'

/*
 * Price segments resolve for any value — /197-per-month returns cars under £197 — but only the
 * values we actually advertise in the sitemap, CMS and crawlable links are worth indexing.
 * Anything off the list still renders and stays self-canonical; it is just marked noindex.
 *
 * This is option D of the four put to Rob, and the team's recommendation: the alternatives either
 * break shared links (404), show a different figure than the URL states (snap to nearest), or
 * canonicalise two pages that return different results to each other. Pending his decision, and
 * pending sign-off on the approved value list — the static filter options are the starting point
 * named in the plan, not a confirmed list.
 */
export const isIndexablePriceSegment = (
  pathSegmentFilters: Partial<SearchFilters>,
): boolean => {
  const monthlyPrice = pathSegmentFilters.monthlyPrice?.[0]
  const totalPrice = pathSegmentFilters.totalPrice?.[0]

  if (monthlyPrice !== undefined) {
    return payMonthlyRange.some((option) => `${option.value}` === monthlyPrice)
  }

  if (totalPrice !== undefined) {
    return payFullRange.some((option) => `${option.value}` === totalPrice)
  }

  // Not a price page, so this rule has nothing to say about it
  return true
}

export const hasPriceSegment = (
  pathSegmentFilters: Partial<SearchFilters>,
): boolean =>
  (pathSegmentFilters.monthlyPrice?.length ?? 0) > 0 ||
  (pathSegmentFilters.totalPrice?.length ?? 0) > 0
